/** @jsx jsx */
import { jsx } from '@emotion/core'
import style from './summaryStyle';

import utils from '../../../utils';
import { Fragment } from 'react';

export function CartSummary({ cart }) {
  //console.log('cart', cart);
  const formatMoney = utils.money.formatMoney;

  // Hide the pickup-location panel only when every SKU line is a digital/no-fulfillment
  // item (parking permits). DO NOT key off shippingFeeType — a pickup-only physical
  // product also carries ShippingNotRequired but the customer still needs to know
  // where to collect it.
  const skuItems = (cart.orderItems || []).filter(x => x.orderItemType === 0);
  const isNoFulfillmentCart = skuItems.length > 0 && skuItems.every(x => x.ext && x.ext.isParking);

  return <div css={style.summary}>
    {
      cart.shippingMethod === "Standard" &&
      <Fragment>
        <div css={style.totalHdr}> Shipping </div>
        <div css={style.totalAmount}> AU {formatMoney(cart.shippingAmount)} </div>
        <hr style={{borderTop:'1px solid white'}} />
      </Fragment>
    }
    {
      cart.shippingMethod === "Pickup" && !isNoFulfillmentCart &&
      <Fragment>
        <div css={style.pickupSection}>
          <div css={style.pickupTitle}>Pickup Location</div>
          <div css={style.pickupAddress}><strong>Whyalla Visitor Centre, Lincoln Highway</strong></div>
          <div css={style.pickupDetails}>
            <div><strong>Opening Hours:</strong></div>
            <ul css={style.pickupHoursList}>
              <li>Mon–Fri: 9am–4pm</li>
              <li>Weekends & Public Holidays: 10am–4pm</li>
            </ul>
            <div><strong>Closed:</strong> Good Friday & Christmas Day</div>
            {/* <div css={style.pickupTime}>Usually ready in 24 hours</div> */}
          </div>
        </div>
        <hr style={{borderTop:'1px solid white'}} />
      </Fragment>
    }
    <div css={style.totalSection}>
      <div css={style.totalHdr}>Total Amount</div>
      <div css={style.totalAmount}>AU {formatMoney(cart.totalAmount)}</div>
    </div>
  {/* <div class="row">
    <div class="col-md-6">Total:</div>
    <div class="col-md-6">AU {formatMoney(cart.itemAmount)}</div>
  </div>
  <div class="row">
    <div class="col-md-6">GST:</div>
    <div class="col-md-6">AU {formatMoney(cart.taxAmount)}</div>
  </div> */}
  {/* <div class="row">
    <div class="col-md-6">Shipping:</div>
    <div class="col-md-6">
      <span *ngIf="!shippingMethod">Method not selected yet</span>
      <span *ngIf="shippingMethod == 'Pickup'">Pickup - FREE</span>
      <span *ngIf="shippingMethod == 'Shipping'">{{cart.shippingAmount > 0? 'AU ' + formatMoney(cart.shippingAmount) : 'FREE'}}</span>
    </div>
  </div>
  <div class="row total">
    <div class="col-md-6"></div>
    <div class="col-md-6">
      <span>{{cart.shippingMethod == ''? 'Please select Shipping Option.': 'AU ' + formatMoney(cart.totalAmount)}}</span>
    </div>
  </div>
 */}
</div>
}